module.exports = __webpack_public_path__ + "img/all.7de991a.webp";